import { YOUNG_ALFRED_STORAGE_KEY } from 'common/constants'

const getInsurancePrefillData = () => {
  const savedYAData = JSON.parse(window.localStorage.getItem(YOUNG_ALFRED_STORAGE_KEY))
  const prefill = savedYAData ? savedYAData.application.start : {}

  const obj = Object.keys(prefill).reduce(
    (acc, curr) => ({
      ...acc,
      ...(!!prefill[curr] && { [curr]: prefill[curr] }),
    }),
    {},
  )

  return obj
}

export default getInsurancePrefillData
